import { Button } from "antd";
import { useNavigate } from "react-router";

export default function NoMatch() {
  const navigate = useNavigate();
  const goToLogin = () => {
    navigate("/login");
  };
  return (
    <div className="flex items-center justify-center m-5 min-h-screen rounded-md bg-[#FFF]">
      {/* <BugIcon /> */}
      <div className="w-[25%] ml-[100px]">
        <p className="text-[#06709B] text-[18px]">ERROR</p>
        <p className="text-[24px] mb-2">Page Not Found</p>
        <p className="text-[#2B4752]">
          The page you are looking for does not exist.
        </p>
        <p className="text-[#2B4752]">
          Please check the URL or go back to login.
        </p>
        <Button
          onClick={goToLogin}
          variant="outlined"
          className="mt-3 w-[147px] bg-[#D2EFF9] text-[#064C68] border-[#064C68]"
        >
          Go back to Login
        </Button>
      </div>
    </div>
  );
}
